import React from 'react'

import PlansBlock from '../PlansBlock'
import ExperimentVariantA from '../ExperimentVariantA'
import {
  EPricingExperimentVariant,
  usePricingExperimentInfo,
} from '../experiment'

import type { ICommonPlansBlockProps } from '@/contexts/PlanContext/type'

export interface IExperimentPlansEntryProps extends ICommonPlansBlockProps {}

const ExperimentPlansEntry: React.FC<IExperimentPlansEntryProps> = (props) => {
  const { productList } = props
  const { variant, effectiveUserGroup } = usePricingExperimentInfo(productList)

  if (variant === EPricingExperimentVariant.A) {
    return (
      <ExperimentVariantA {...props} effectiveUserGroup={effectiveUserGroup} />
    )
  }

  return <PlansBlock {...props} effectiveUserGroup={effectiveUserGroup} />
}

export default ExperimentPlansEntry
